import type { Transition, Variants } from 'motion/react'

export const WINDOW_WRAPPER_ANIMATION: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
}

export const WINDOW_CONTENT_ANIMATION: Variants = {
  initial: { scale: 0.8, opacity: 0, y: -20 },
  animate: { scale: 1, opacity: 1, y: 0 },
  exit: { scale: 0.8, opacity: 0, y: -20 }
}

export const WINDOW_SPRING_TRANSITION: Transition = {
  duration: 0.2,
  type: 'spring',
  damping: 20,
  stiffness: 300
}

export const WINDOW_FADE_TRANSITION: Transition = {
  duration: 0.2
}
